import { Box } from '@arpeggi/ui'
import { useContext, useEffect } from 'react'
import { StyledCanvas, useConfetti } from '../../../core/Confetti'
import CopyTextButton from '../../../core/CopyTextButton'
import { Graphics, topGraphics } from '../../../core/Graphics'
import { ModalComponents } from '../../../core/Modal'
import { RegisterModalContext } from './RegisterSongModal'

export const ConfirmationPage = () => {
  const { state } = useContext(RegisterModalContext)
  const { getInstance, fireConfetti } = useConfetti()

  useEffect(() => {
    fireConfetti()
  }, [])

  return (
    <ModalComponents.Container css={{ alignItems: 'center', justifyContent: 'center' }}>
      <Graphics className={topGraphics()} />
      <ModalComponents.Title>Congratulations!</ModalComponents.Title>
      <ModalComponents.Subtitle>
        Your song has been minted! View your song page by following the link below.
      </ModalComponents.Subtitle>
      <Box css={{ marginBottom: '16px ' }}>
        <CopyTextButton
          link={`${window.location.origin}/song-preview/${state.createdMintStatus?.jobId}`}
        />
      </Box>
      <StyledCanvas refConfetti={getInstance} />
    </ModalComponents.Container>
  )
}
